(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ts-product"] && !Shopify.designMode) return;
  try {
    
(function () {
  function init(root) {
    if (root.dataset.tsReady) return; root.dataset.tsReady = '1';
    var imgs = root.querySelectorAll('.ts-gallery__main .ts-gallery__img');
    var thumbs = root.querySelectorAll('.ts-gallery__thumbs button');
    function show(i) {
      imgs.forEach(function (el, n) { el.classList.toggle('is-active', n === i); });
      thumbs.forEach(function (el, n) { el.classList.toggle('is-active', n === i); el.setAttribute('aria-selected', n === i); });
    }
    thumbs.forEach(function (b, n) { b.addEventListener('click', function () { show(n); }); });
    if (imgs.length) show(0);

    var price = root.querySelector('[data-ts-price]');
    var atcPrice = root.querySelector('[data-ts-atc-price]');
    var sName = root.querySelector('[data-ts-sticky-name]');
    var sPrice = root.querySelector('[data-ts-sticky-price]');
    root.querySelectorAll('.ts-bundle input[type=radio]').forEach(function (r) {
      r.addEventListener('change', function () {
        if (!r.checked) return;
        if (price) price.textContent = r.dataset.price;
        if (atcPrice) atcPrice.textContent = r.dataset.price;
        if (sPrice) sPrice.textContent = r.dataset.price;
        if (sName) sName.textContent = 'TideSip · ' + r.dataset.name;
        if (window.history && window.history.replaceState && /\/products\//.test(location.pathname)) {
          var u = new URL(location.href); u.searchParams.set('variant', r.value); history.replaceState({}, '', u);
        }
      });
    });

    var sticky = root.querySelector('[data-ts-sticky]');
    var atc = root.querySelector('[data-ts-atc]');
    if (sticky && atc && 'IntersectionObserver' in window) {
      new IntersectionObserver(function (entries) {
        var e = entries[0];
        var past = !e.isIntersecting && e.boundingClientRect.top < 0;
        sticky.classList.toggle('is-visible', past);
        sticky.setAttribute('aria-hidden', past ? 'false' : 'true');
        sticky.querySelector('button').tabIndex = past ? 0 : -1;
      }).observe(atc);
    }
  }
  function boot() { document.querySelectorAll('[data-ts-product]').forEach(init); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
  document.addEventListener('shopify:section:load', boot);
})();

  } catch(e) { console.error(e); }
})();
})();
